import axiosClient from "../lib/axiosClient";

export const singIn = async (form) => {
  try {
    const response = await axiosClient.post("/sign-in", { user: form });
    return response;
  } catch (error) {
    throw error;
  }
};

export const singUp = async (form) => {
  try {
    const response = await axiosClient.post("/sign-up", { user: form });
    return response;
  } catch (error) {
    throw error;
  }
};

export const requestResetPassword = async (form) => {
  try {
    const response = await axiosClient.post("/users/password", { user: form });
    return response;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (form, resetToken) => {
  try {
    const response = await axiosClient.put("/users/password", {
      user: {
        reset_password_token: resetToken,
        password: form.password,
        password_confirmation: form.password_confirmation,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (form) => {
  try {
    const response = await axiosClient.put("/sign-up", { user: form });
    return response;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    const response = await axiosClient.delete("/sign-out");
    return response;
  } catch (error) {
    throw error;
  }
};
